export interface ICodeNameUrl {
    code: string;
    name: string;
    url: string;
}

export class CodeNameUrl implements ICodeNameUrl {
    code: string;
    name: string;
    url: string;

    constructor();
    constructor(obj: ICodeNameUrl);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.url = obj && obj.url || "";
    }
}